import request from '@/router/axios'

const BASE = '/api/produce/power-room-alarm'

export const overview = (data) => request({
  url: `${BASE}/overview`,
  method: 'post',
  data
})

export const page = (data) => {
  const payload = { ...data }
  if (payload.page !== undefined && payload.current === undefined) {
    payload.current = payload.page
    delete payload.page
  }
  if (payload.pageSize !== undefined && payload.size === undefined) {
    payload.size = payload.pageSize
    delete payload.pageSize
  }
  return request({
    url: `${BASE}/page`,
    method: 'post',
    data: payload
  })
}

export const detail = (id) => request({
  url: `${BASE}/detail`,
  method: 'get',
  params: { id }
})

export const process = (data) => request({
  url: `${BASE}/process`,
  method: 'post',
  data
})

export const submitWorkOrder = (data) => request({
  url: `${BASE}/work-order/submit`,
  method: 'post',
  data
})
